export default "__VITE_ASSET__90484ba2__"